import classNames from 'classnames';
import queryString from 'query-string';
import Placeholder from '../Placeholder';
import './styles/BillingItemList.scss'

import React from 'react';
import { formatCurrency, formatDate, formatDateTime } from '../../utils/i18n';
import {titleize} from '../../utils/strings';
import {formatBillingContact} from "components/billing/BillingItemList";
import PropTypes from 'prop-types';
import FontAwesome from 'utils/FA';
import { billingItems, billingContacts } from '../../ducks/index';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faSort} from '@fortawesome/pro-solid-svg-icons/faSort'
import {faSortDown} from '@fortawesome/pro-solid-svg-icons/faSortDown'
import {faSortUp} from '@fortawesome/pro-solid-svg-icons/faSortUp'
import { duckify, filterDuck, singleDuck } from '../../utils/duckify';
import { compose } from 'redux';
import Pagination from 'react-ultimate-pagination-bootstrap-4';
import withPagination from '../../hocs/withPagination'
import withFiltering from '../../hocs/withFiltering';
import withSorting from 'hocs/withSorting';
import { withRouter, Link } from 'react-router';
import {sortInverse} from 'utils/UriSorting'

const BillingAmount = ({amount, split, deleted, ...props}) => {
  return (
    <tr className={deleted} {...props}>
      <td/>
      <td><div className={deleted ? "billing-contact" : "sub billing-contact"}>{formatBillingContact(amount.billing_contact)}</div></td>
      <td><div className={deleted ? "billing-category" : "sub billing-category"}>{amount.billing_category.name}</div></td>
      <td><div className={deleted ? "billing-amount" : "sub billing-item-amount"}>{split && formatCurrency(amount.amount)}</div></td>
      <td/>
      <td/>
    </tr>
  );
};

const BillingAuditViewer = ({ onRepostItem, items, page, setPage, sort, onSort }) => {
  const totalPages = Math.ceil(items.total/ items.perPage)

  return (
      <Placeholder.loading ready={items.ready}>
        {totalPages > 1 && (
          <div>
            <div className="contact-list-react-pagination">
              <div className="pagination pagination-right">
                <Pagination
                  currentPage={page}
                  totalPages={totalPages}
                  hideFirstAndLastPageLinks
                  onChange={setPage}
                />
              </div>
            </div>
          </div>
        )}
        <table className={'billing-item-list table table-borderless'}>
          <thead>
          <tr>
            <th className="billing-item-date">Date</th>
            <th>Description</th>
            <th>Type / Category</th>
            <th className="billing-item-amount">Amount</th>

            <th className="billing-item-date sortable" >
              <Link to={onSort('created_at', ('created_at' === sort.column) ? sortInverse(sort.order) : 'desc')} >
                Created On
                <FontAwesomeIcon icon={(sort.column === 'created_at' && sort.order === 'asc' ? faSortUp : sort.column === 'created_at' && sort.order === 'desc' ? faSortDown : faSort)}/>
              </Link>
            </th>
            <th className="sortable" >
              <Link to={onSort('created_by', ('created_by' === sort.column) ? sortInverse(sort.order) : 'desc')} >
                Created By
                <FontAwesomeIcon icon={(sort.column === 'created_by' && sort.order === 'asc' ? faSortUp : sort.column === 'created_by' && sort.order === 'desc' ? faSortDown : faSort)} />
              </Link>
            </th>

            <th></th>

            <th className="billing-item-date sortable" >
              <Link to={onSort('deleted_at', ('deleted_at' === sort.column) ? sortInverse(sort.order) : 'desc')} >
                Deleted On
                <FontAwesomeIcon icon={(sort.column === 'deleted_at' && sort.order === 'asc' ? faSortUp : sort.column === 'deleted_at' && sort.order === 'desc' ? faSortDown : faSort)} />
              </Link>
            </th>
            <th className="sortable" >
              <Link to={onSort('deleted_by', ('deleted_by' === sort.column) ? sortInverse(sort.order) : 'desc')} >
                Deleted By
                <FontAwesomeIcon icon={(sort.column === 'deleted_by' && sort.order === 'asc' ? faSortUp : sort.column === 'deleted_by' && sort.order === 'desc' ? faSortDown : faSort)} />
              </Link>
            </th>
          </tr>
          </thead>
          {items.map((item, i) =>
            <BillingItem
              key={i}
              item={item}
              onRepostItem={onRepostItem}
            />)}

          {items.length === 0 && <tbody>
          <tr>
            <td colSpan="6"><em>No billing items found.</em></td>
          </tr>
          </tbody>}

        </table>
      </Placeholder.loading>
  );
};

BillingAuditViewer.propTypes = {
  onRepostItem: PropTypes.func.isRequired
};

const BillingItem = ({item, onRepostItem, ...props}) => {
  const allowRepost = !!item.deleted_at && !item.replaced_by_id;

  return (
    <tbody {...props}>
    <tr className={item.deleted_at ? 'billing-item-deleted' : ""}>
      <td className="billing-item-date">{formatDate(item.billing_date)}</td>
      <td className="billing-item-description">
        <div>{item.description}</div>
      </td>
      <td className="billing-item-type">
        <div>{titleize(item.type)}</div>
      </td>
      <td className={classNames("billing-item-amount", {'negative-number': item.amount < 0})}>
        <div>{formatCurrency(item.amount)}</div>
      </td>
      <td className="billing-item-created-at">
        <div title={item.created_at ? formatDateTime(item.created_at) : ''}>
          {item.created_at ? formatDate(item.created_at) : ''}
        </div>
      </td>
      <td className="billing-item-created-by">
        <div>{item.created_by}</div>
      </td>
      <td>
        <div>
          {allowRepost && (
            <button className='btn btn-xs btn-primary billing-item-repost' title='Repost Item' onClick={() => onRepostItem(item)}>
              <FontAwesome name='undo' />
            </button>
          )}
        </div>
      </td>
      <td className="billing-item-deleted-at">
        <div title={item.deleted_at ? formatDateTime(item.deleted_at) : ''}>
          {item.deleted_at ? formatDate(item.deleted_at) : ''}
        </div>
      </td>
      <td className="billing-item-deleted-by">
        <div>{item.deleted_by}</div>
      </td>
    </tr>
    {item.billing_item_amounts.map(amount => <BillingAmount amount={amount}
                                                            split={item.billing_item_amounts.length > 1}
                                                            key={amount.id}
                                                            deleted={item.deleted_at ? 'billing-item-deleted'  : "" }/>)}
    </tbody>
  );
};

const mapDucksToProps = ({
  billingAccountId, page, perPage, location,
}) => {
  let fullFilters = {
    billing_account_id: billingAccountId,
    page: page || 1,
    per_page: perPage,
  };

  return {
    items: filterDuck(billingItems, {
      ...fullFilters,
      ...queryString.parse(location.search),
      include_deleted: true,
    }),
    accountBillingContacts: filterDuck(billingContacts, { billing_account_id: billingAccountId })
  };
};

export default compose(
  withRouter,
  withPagination,
  withFiltering,
  withSorting({ column: '', order: 'asc' }),
  duckify(mapDucksToProps)
  )(BillingAuditViewer);
